import type React from "react";
import styles from "./HighlightCard.module.scss";

export const HighlightCard = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.card}>{children}</div>;
};
